/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassShort } from './MktuClassShort'
import {
  MktuClassShortFromJSON,
  MktuClassShortFromJSONTyped,
  MktuClassShortToJSON,
} from './MktuClassShort'

/**
 * Элемент результата поиска по реестрам (товарный знак / заявка на товарный знак)
 * @export
 * @interface RegistrySearchItem
 */
export interface RegistrySearchItem {
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  registrationOfficeCode?: string | null
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  number: string
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  scope?: RegistrySearchItemScopeEnum | null
  /**
   *
   * @type {Date}
   * @memberof RegistrySearchItem
   */
  expiryDate?: Date | null
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  owner?: string | null
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  address?: string | null
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  folderName?: string | null
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  imageUrl?: string | null
  /**
   *
   * @type {string}
   * @memberof RegistrySearchItem
   */
  fallbackImageUrl: string
  /**
   *
   * @type {Array<MktuClassShort>}
   * @memberof RegistrySearchItem
   */
  mktuClasses?: Array<MktuClassShort>
}

/**
 * @export
 * @enum {string}
 */
export enum RegistrySearchItemScopeEnum {
  Application = 'application',
  Registry = 'registry',
}

/**
 * Check if a given object implements the RegistrySearchItem interface.
 */
export function instanceOfRegistrySearchItem(
  value: object
): value is RegistrySearchItem {
  if (!('number' in value) || value['number'] === undefined) return false
  if (!('fallbackImageUrl' in value) || value['fallbackImageUrl'] === undefined)
    return false
  return true
}

export function RegistrySearchItemFromJSON(json: any): RegistrySearchItem {
  return RegistrySearchItemFromJSONTyped(json, false)
}

export function RegistrySearchItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistrySearchItem {
  if (json == null) {
    return json
  }
  return {
    registrationOfficeCode:
      json['registrationOfficeCode'] == null
        ? undefined
        : json['registrationOfficeCode'],
    number: json['number'],
    scope: json['scope'] == null ? undefined : json['scope'],
    expiryDate:
      json['expiryDate'] == null ? undefined : new Date(json['expiryDate']),
    owner: json['owner'] == null ? undefined : json['owner'],
    address: json['address'] == null ? undefined : json['address'],
    folderName: json['folderName'] == null ? undefined : json['folderName'],
    imageUrl: json['imageUrl'] == null ? undefined : json['imageUrl'],
    fallbackImageUrl: json['fallbackImageUrl'],
    mktuClasses:
      json['mktuClasses'] == null
        ? undefined
        : (json['mktuClasses'] as Array<any>).map(MktuClassShortFromJSON),
  }
}

export function RegistrySearchItemToJSON(
  value?: RegistrySearchItem | null
): any {
  if (value == null) {
    return value
  }
  return {
    registrationOfficeCode: value['registrationOfficeCode'],
    number: value['number'],
    scope: value['scope'],
    expiryDate:
      value['expiryDate'] == null
        ? undefined
        : (value['expiryDate'] as any).toISOString(),
    owner: value['owner'],
    address: value['address'],
    folderName: value['folderName'],
    imageUrl: value['imageUrl'],
    fallbackImageUrl: value['fallbackImageUrl'],
    mktuClasses:
      value['mktuClasses'] == null
        ? undefined
        : (value['mktuClasses'] as Array<any>).map(MktuClassShortToJSON),
  }
}
